// extracted by mini-css-extract-plugin
export default {"StepIcon":"StepIcon_StepIcon__YlrpP","hatchimg":"StepIcon_hatchimg__Ezwny"};